// this is an autogenerated file from App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/Actions/Disconnect/Content/DisconnectAction/mutation-mark-connection-inactive.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_ConnectApps_App_Content_Connections_Content_ActionsColumn_Actions_Disconnect_Content_DisconnectAction($id: uuid!) {
  apps_connection_disconnect(id: $id) {
    id
    ok
  }
}

`